import React from 'react'
import { Link } from 'gatsby'
import logo from '../img/logo.webp'

const Navbar = class extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      active: false,
      navBarActiveClass: '',
    }
  }

  toggleHamburger = () => {
    // toggle the active boolean in the state
    this.setState(
      {
        active: !this.state.active,
      },
      // after state has been updated,
      () => {
        // set the class in state for the navbar accordingly
        this.state.active
          ? this.setState({
              navBarActiveClass: 'is-active',
            })
          : this.setState({
              navBarActiveClass: '',
            })
      }
    )
  }

  render() {
    return (
      <nav
        className="navbar is-transparent"
        role="navigation"
        aria-label="main-navigation"
      >
        <div className="container-block">
          <div className="container">
            <div className="brand-container">
              <div>
                <Link to="/" title="Logo">
                  <img src={logo} alt="Ancestral Link" style={{ width: '120px', height: '120px' }} />
                </Link>
                {/* Hamburger menu */}
                <div
                  className={`navbar-burger burger ${this.state.navBarActiveClass}`}
                  data-target="navMenu"
                  onClick={() => this.toggleHamburger()}
                >
                  <span />
                  <span />
                  <span />
                </div>
              </div>
              <div className="header-text">
                Ancestral Link
                <div className="header-tagline">
                  Handcrafted Traditional Drums by David Fierro
                </div>
              </div>
              <div className="login align-right width50">
                <p>Login</p>
              </div>
            </div>
          </div>
          <div
              id="navMenu"
              className={`navbar-menu ${this.state.navBarActiveClass}`}
            >
            <div className="navbar-start navbar-back">
              <Link className="navbar-item link" to="/">
                Home
              </Link>
              <Link className="navbar-item link" to="/gallery">
                Gallery
              </Link>
              <Link className="navbar-item link" to="/shop">
                Shop
              </Link>
              <Link className="navbar-item link" to="/workshops">
                Workshops
              </Link>
              <Link className="navbar-item link" to="/about">
                About
              </Link>
              <Link className="navbar-item link" to="/contact">
                Contact
              </Link>
            </div>
          </div>
          <div className="navbar-padding"/>
        </div>
      </nav>
    )
  }
}

export default Navbar
